var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeutral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5488 35C27.2138 35 35.0488 27.165 35.0488 17.5C35.0488 7.83502 27.2138 0 17.5488 0C7.88384 0 0.0488281 7.83502 0.0488281 17.5C0.0488281 27.165 7.88384 35 17.5488 35Z",
    fill: "url(#paint0_radial_321_38)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.5488 35C27.2138 35 35.0488 27.165 35.0488 17.5C35.0488 7.83502 27.2138 0 17.5488 0C7.88384 0 0.0488281 7.83502 0.0488281 17.5C0.0488281 27.165 7.88384 35 17.5488 35Z",
    fill: "url(#paint1_radial_321_38)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3876 9.8438C14.4969 9.01254 13.8079 8.38911 12.5173 8.22504C11.4126 8.08285 8.90788 8.49848 6.91725 10.85C6.54538 11.2875 6.98288 11.6047 7.33288 11.3422C8.49225 10.4344 11.4016 9.45004 13.5016 10.0079C14.3438 10.2157 14.3876 9.8438 14.3876 9.8438Z",
    fill: "url(#paint2_linear_321_38)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8397 18.2434C12.7699 18.2434 13.524 17.1024 13.524 15.6949C13.524 14.2875 12.7699 13.1465 11.8397 13.1465C10.9094 13.1465 10.1553 14.2875 10.1553 15.6949C10.1553 17.1024 10.9094 18.2434 11.8397 18.2434Z",
    fill: "url(#paint3_radial_321_38)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8397 14.011C12.5615 14.011 13.1959 14.6454 13.524 15.5751C13.5022 14.197 12.7584 13.0923 11.8397 13.0923C10.9209 13.0923 10.1771 14.197 10.1553 15.5751C10.4834 14.6454 11.1068 14.011 11.8397 14.011Z",
    fill: "url(#paint4_linear_321_38)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2586 18.2434C24.1889 18.2434 24.943 17.1024 24.943 15.6949C24.943 14.2875 24.1889 13.1465 23.2586 13.1465C22.3283 13.1465 21.5742 14.2875 21.5742 15.6949C21.5742 17.1024 22.3283 18.2434 23.2586 18.2434Z",
    fill: "url(#paint5_radial_321_38)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2586 14.077C22.5367 14.077 21.9023 14.7113 21.5742 15.641C21.5961 14.2629 22.3398 13.1582 23.2586 13.1582C24.1773 13.1582 24.9211 14.2629 24.943 15.641C24.6149 14.7113 23.9914 14.077 23.2586 14.077Z",
    fill: "url(#paint6_linear_321_38)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7095 9.8438C20.6002 9.01254 21.2892 8.38911 22.5799 8.22504C23.6845 8.08285 26.1892 8.49848 28.1799 10.85C28.5517 11.2875 28.1142 11.6047 27.7642 11.3422C26.6049 10.4344 23.6955 9.45004 21.5955 10.0079C20.7533 10.2157 20.7095 9.8438 20.7095 9.8438Z",
    fill: "url(#paint7_linear_321_38)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9205 25.1343H10.1768C9.72832 25.1343 9.35645 24.7624 9.35645 24.314C9.35645 23.8655 9.72832 23.4937 10.1768 23.4937H24.9205C25.3689 23.4937 25.7408 23.8655 25.7408 24.314C25.7408 24.7624 25.3689 25.1343 24.9205 25.1343Z",
    fill: "url(#paint8_radial_321_38)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1002 23.9311H25.008C25.3252 23.9311 25.6096 24.1171 25.7408 24.3796C25.7408 24.3577 25.7408 24.3358 25.7408 24.314C25.7408 23.8655 25.3689 23.4937 24.9205 23.4937H10.1768C9.72832 23.4937 9.35645 23.8655 9.35645 24.314C9.35645 24.3358 9.35645 24.3577 9.35645 24.3796C9.49863 24.1061 9.77207 23.9311 10.1002 23.9311Z",
    fill: "url(#paint9_linear_321_38)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_321_38",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1057 10.4078) scale(21.1115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_321_38",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1057 10.4078) scale(16.6093)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_321_38",
    x1: 10.5507,
    y1: 10.7707,
    x2: 10.8343,
    y2: 8.57666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_321_38",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.3243 15.7621) rotate(73.8539) scale(2.47262 1.59975)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_321_38",
    x1: 11.8355,
    y1: 13.1371,
    x2: 11.8355,
    y2: 15.5121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_321_38",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7521 15.7625) rotate(73.8539) scale(2.47262 1.59975)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_321_38",
    x1: 23.2628,
    y1: 13.1999,
    x2: 23.2628,
    y2: 15.5749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_321_38",
    x1: 24.547,
    y1: 10.7713,
    x2: 24.2634,
    y2: 8.57722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_321_38",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5486 24.3094) scale(5.82174 1.04733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_321_38",
    x1: 9.35642,
    y1: 23.9306,
    x2: 25.7408,
    y2: 23.9306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/Neutral.000f2c7082c80c934d10645fd300abd0.svg";
export { ForwardRef as ReactComponent };